/**
 * Softphone/deskphone SIP analytics (`sipc_*`). Properties must stay PHI-clean:
 * ids, flags, durations, and quality numbers — never dialed numbers, names,
 * SDP, or message bodies.
 */
export enum SipClientAnalyticsEvents {
  /** Softphone REGISTER succeeded. */
  SipRegistered = 'sip_registered',
  /** Outbound INVITE sent — the denominator for call connect-success rate. */
  CallPlaced = 'call_placed',
  CallConnected = 'call_connected',
  CallEnded = 'call_ended',
  CallFailed = 'call_failed',
  CallQualitySummary = 'call_quality_summary',
  CallQualityDegraded = 'call_quality_degraded',
  WssConnFailure = 'wss_conn_failure',
  UnregFailure = 'unreg_failure',
  RegFailure = 'reg_failure',
  InvReceived = 'inv_received',
  AnswerFailure = 'answer_failure',
  RejectFailure = 'reject_failure',
  StartCallFailure = 'start_call_failure',
  SessRejectBusyFailure = 'sess_reject_busy_failure',
  SessCancelFailure = 'sess_cancel_failure',
  SessRejectFailure = 'sess_reject_failure',
  SessByeFailure = 'sess_bye_failure',
  MuteFailure = 'mute_failure',
  UnmuteFailure = 'unmute_failure',
  HoldFailure = 'hold_failure',
  TransferRequest = 'transfer_request',
  TransferFailure = 'transfer_failure',
  AttendedTransferFailure = 'attended_transfer_failure',
  DtmfFailure = 'dtmf_failure',
}
